import { alpha } from '@mui/material/styles';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import React from 'react';

interface AnonymousMarketplaceHeroProps {
  eyebrow?: string;
  title: string;
  description: string;
  browseHref?: string;
  secondaryLabel?: string;
  secondaryHref?: string;
  accentColor?: string;
}

export const AnonymousMarketplaceHero: React.FC<AnonymousMarketplaceHeroProps> = ({
  eyebrow = 'BETA · REAL PRICING · TRANSPARENT COMPETITION',
  title,
  description,
  browseHref = '#catalog',
  secondaryLabel,
  secondaryHref,
  accentColor = '#c9a227',
}) => {
  const accentWash = alpha(accentColor, 0.16);
  const accentBorder = alpha(accentColor, 0.14);

  return (
    <Box
      sx={{
        bgcolor: '#f7f4ea',
        color: '#1f1a12',
        pt: { xs: 10, md: 8 },
        pb: { xs: 5, md: 5 },
        borderBottom: `1px solid ${accentBorder}`,
        background: `radial-gradient(ellipse at 20% 20%, rgba(33,150,243,0.08) 0%, transparent 50%), radial-gradient(ellipse at 80% 60%, ${accentWash} 0%, transparent 50%), linear-gradient(180deg, #fbf8ef 0%, #f5f1e5 100%)`,
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ maxWidth: 900 }}>
          <Typography sx={{ color: accentColor, fontSize: '0.82rem', fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', mb: 1.75 }}>
            {eyebrow}
          </Typography>
          <Typography variant="h1" sx={{ color: '#1f1a12', fontWeight: 900, fontSize: { xs: '2.3rem', md: '3.6rem' }, lineHeight: { xs: 1.12, md: 1.08 }, mb: 2 }}>
            {title}
          </Typography>
          <Typography sx={{ color: 'rgba(31,26,18,0.82)', fontSize: { xs: '1rem', md: '1.16rem' }, lineHeight: 1.65, maxWidth: 760, mb: 3.5 }}>
            {description}
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <Button variant="contained" size="large" href={browseHref} sx={{ alignSelf: { xs: 'stretch', sm: 'flex-start' } }}>
              Browse Services ↓
            </Button>
            {secondaryLabel && secondaryHref && (
              <Button
                variant="outlined"
                size="large"
                href={secondaryHref}
                sx={{
                  color: '#6f5720',
                  borderColor: 'rgba(111,87,32,0.28)',
                  bgcolor: 'rgba(255,255,255,0.55)',
                  alignSelf: { xs: 'stretch', sm: 'flex-start' },
                  '&:hover': { borderColor: '#8b6b20', bgcolor: 'rgba(255,255,255,0.82)' },
                }}
              >
                {secondaryLabel} →
              </Button>
            )}
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default AnonymousMarketplaceHero;
